import { Breadcrumb } from '@amzn/storm-ui';
import React, { useMemo } from 'react';
import { LinkBreadcrumb } from './LinkBreadcrumb';
import { TextBreadcrumb } from './TextBreadcrumb';
import type { Breadcrumb as BreadcrumbType } from '../../../../app/slice';

export const getBreadcrumbLabel = (item: BreadcrumbType | undefined): string =>
  item
    ? item.objectType
      ? `${item.objectType}: ${item.label}`
      : item.label
    : '';

export const getBreadcrumbContentWidths = (
  elements: Array<HTMLElement | Element>,
) => {
  const acc: number[] = [];
  for (let i = elements.length - 1; i >= 0; i--) {
    const rectWidth = elements[i].getBoundingClientRect().width;
    if (i === elements.length - 1) {
      acc.push(rectWidth);
    } else {
      acc.push(acc[elements.length - i - 2] + rectWidth);
    }
  }
  return acc;
};

export const getRefWidth = (ref) => ref?.current?.offsetWidth ?? -1;

// use this function to generate a hash of the breadcrumb labels
// as an unique identifier of the breadcrumbs.  This is used to check
// if breadcrumbs have been updated.  We can add more fields to this
// to make it more unique
export const getBreadcrumbHash = (breadcrumbs: BreadcrumbType[]) => {
  return breadcrumbs.map((b) => b.label).join('');
};

export const getTotalBreadcrumbs = (
  breadcrumbs: BreadcrumbType[] | undefined,
  pageTitleBreadcrumb: BreadcrumbType | undefined,
) => [
  ...(breadcrumbs || []),
  { label: getBreadcrumbLabel(pageTitleBreadcrumb) },
];

//needs to wrap breadcrumb content with Breadcrumb because storm-ui check the child type of BreadcrumbGroup
//if it's not native Breadcrumb, it'll always render a caretIcon in the end, which doesn't fit our usecase
export const breadcrumbList = (
  totalBreadcrumbs: Array<BreadcrumbType>,
  breadcrumbHash: string,
) =>
  useMemo(
    () =>
      totalBreadcrumbs.map((breadcrumb) => (
        <Breadcrumb key={breadcrumb.label}>
          {breadcrumb.url || breadcrumb.onClickCallback ? (
            <LinkBreadcrumb breadcrumb={breadcrumb} />
          ) : (
            <TextBreadcrumb breadcrumb={breadcrumb} />
          )}
        </Breadcrumb>
      )),
    [breadcrumbHash],
  );
